import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { PublicHealthRecordType } from '../public-health-record-type.model';

export enum PublicHealthRecordTypeActionTypes {
  LoadPublicHealthRecordTypes = '[PublicHealthRecordTypes] Load',
  LoadPublicHealthRecordTypesSuccess = '[PublicHealthRecordTypes] Load success',
  LoadPublicHealthRecordTypesFail = '[PublicHealthRecordTypes] Load fail',
}

@ShowLoader()
export class LoadPublicHealthRecordTypes implements Action {
  readonly type = PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypes;
}
@HideLoader(PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypes)
export class LoadPublicHealthRecordTypesSuccess implements Action {
  readonly type = PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypesSuccess;
  constructor(public payload: PublicHealthRecordType[]) { }
}
@HideLoader(PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypes)
export class LoadPublicHealthRecordTypesFail implements Action {
  readonly type = PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypesFail;
  constructor(public payload: string) { }
}


export type PublicHealthRecordTypeActions =
  LoadPublicHealthRecordTypes | LoadPublicHealthRecordTypesSuccess | LoadPublicHealthRecordTypesFail;
